import { amplitudeService } from 'services/amplitude';

export const sendClickEmailEvent = (type: string) => {
    amplitudeService.sendData('signup: click on email shortcut', {
        type,
    });
};

export const sendChangeEmailEvent = () => {
    amplitudeService.sendData('signup: click on change email');
};
